<template>
    <div
        class="relative flex h-full w-full flex-col items-center justify-center gap-1.5 overflow-hidden rounded-inherit px-2 text-center"
        :style="{ background: bg }"
    >
        <div
            class="pointer-events-none absolute inset-0 rounded-inherit border-hairline border-dashed"
            :style="{
                borderColor: dark ? 'rgba(255,255,255,0.28)' : 'rgba(0,0,0,0.2)'
            }"
        ></div>
        <ImagePlaceholderIcon
            class="h-6 w-6 shrink-0 opacity-45"
            :style="{ color: dark ? '#F3EFE8' : '#1C1A17' }"
        />
        <span
            class="max-w-90pct truncate text-2.75 font-medium leading-tight"
            :style="{
                color: dark ? 'rgba(243,239,232,0.65)' : 'rgba(28,26,23,0.55)'
            }"
            >{{ label }}</span
        >
    </div>
</template>

<script>
import ImagePlaceholderIcon from "@/components/icons/ImagePlaceholderIcon.vue";

export default {
    name: "PlaceholderImage",
    components: { ImagePlaceholderIcon },
    props: {
        label: { type: String, required: true },
        bg: { type: String, required: true },
        dark: { type: Boolean, default: false }
    }
};
</script>
